var exports = {
  "SF": "linkItem__kha83c",
  "qg": "rowText__bhGHZF",
  "Pp": "issueNumber__oo79uq",
};

module.exports = exports;
